import "core-js/modules/es6.array.filter";
import _get from "lodash/get";
import { getTransactionsBulkStart, getTransactionsBulkEnd, getTransactions, updateTransactionsViewList } from "../actions/yodlee";
import { getTransactionsResultsSetToken } from "../selectors/yodlee";
import { getTransactionData } from "../utils/yodlee";
var IDENTITY_MAX_LIMIT = 500;
export default (function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;
  return function (next) {
    return function (action) {
      var result = next(action);
      var state = getState();

      if (action.type === getTransactionsBulkStart.getType()) {
        var _action$payload = action.payload,
            filter = _action$payload.filter,
            count = _action$payload.count;
        var transactionData = getTransactionData(getState().identity.yodlee.transactions, filter);

        if (transactionData.transactions.length >= count || transactionData.lastPageReached) {
          // This shouldn't happen, but if we somehow already have the transactions we
          // want to fetch, then just cancel the bulk loading.
          dispatch(getTransactionsBulkEnd());
          return result;
        } // Start the bulk loading process


        dispatch(getTransactions({
          offset: transactionData.transactions.length,
          limit: Math.min(count, IDENTITY_MAX_LIMIT),
          filter: filter,
          bulkOptions: {
            count: count
          },
          resultsSetToken: getTransactionsResultsSetToken(state.identity),
          includeDisabledAccounts: !!_get(filter, 'accountId')
        }));
        return result;
      }

      if (action.type === getTransactions.SUCCESS_TYPE && action.meta.bulkOptions) {
        var _action$meta = action.meta,
            _filter = _action$meta.filter,
            bulkOptions = _action$meta.bulkOptions;
        var _count = bulkOptions.count;

        var _transactionData = getTransactionData(getState().identity.yodlee.transactions, _filter); // If this satisfies our desired bulk count, then we are done.


        if (_transactionData.transactions.length >= _count || _transactionData.lastPageReached) {
          dispatch(getTransactionsBulkEnd());
          dispatch(updateTransactionsViewList(_count));
          return result;
        } // Otherwise we need to request more transactions


        var delta = _count - _transactionData.transactions.length;
        dispatch(getTransactions({
          offset: _transactionData.transactions.length,
          limit: Math.min(delta, IDENTITY_MAX_LIMIT),
          filter: _filter,
          bulkOptions: {
            count: _count
          },
          resultsSetToken: getTransactionsResultsSetToken(state),
          includeDisabledAccounts: !!_get(_filter, 'accountId')
        }));
        return result;
      }

      if (action.type === getTransactions.FAIL_TYPE && action.meta.bulkOptions) {
        // If something goes wrong while bulk fetching the transactions
        // then just give up.
        dispatch(getTransactionsBulkEnd());
        dispatch(updateTransactionsViewList());
        return result;
      }

      return result;
    };
  };
});